import { render, staticRenderFns } from "./AllCommentsDialog.vue?vue&type=template&id=87b8b486&scoped=true"
import script from "./AllCommentsDialog.vue?vue&type=script&lang=js"
export * from "./AllCommentsDialog.vue?vue&type=script&lang=js"
import style0 from "./AllCommentsDialog.vue?vue&type=style&index=0&id=87b8b486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b8b486",
  null
  
)

export default component.exports